export const environment = {
    production: false,
    apiVersion: 'v1',
    secretKey: 'f2finterview',
    webUrl: 'https://f2finterview.com',
    empUrl: 'https://employees.f2finterview.com',
    iamUrl: 'https://iam.f2finterview.com',
    attendanceUrl: 'https://attendance.f2finterview.com',
    payrollUrl: 'https://payroll.f2finterview.com',
    reportsUrl: 'http://reports.f2finterview.com',
    webApiUrl: 'https://f2finterview.com/api/v1',
    graphqlUrl: 'https://api.f2finterview.com/graphql',
    googleMapKey: "https://maps.googleapis.com/maps/api/js?key=AIzaSyDdKd9EW-0r04LOc8zn8w74V-jfk3DWacw&libraries=drawing&callback=initMap",
    notificationUrl: 'https://notifications.f2finterview.com',
    tenantUrl: "https://tenant.f2finterview.com",
    assetUrl: 'https://asset.f2finterview.com/',
    adminGraphqlUrl: 'https://admin.f2finterview.com/graphql',
    adminUrl:'https://admin.f2finterview.com'
};